import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Undo = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M7.208 18.5h7.872c2.716 0 4.92-2.308 4.92-5.15 0-2.844-2.204-5.152-4.92-5.152H4.256'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.52 10.775 4 8.137 6.52 5.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.506 8.198a.75.75 0 0 1 .75-.75H15.08c3.162 0 5.67 2.676 5.67 5.901s-2.508 5.901-5.67 5.901H7.208a.75.75 0 0 1 0-1.5h7.872c2.27 0 4.17-1.939 4.17-4.4 0-2.463-1.9-4.402-4.17-4.402H4.256a.75.75 0 0 1-.75-.75'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.037 4.958c.3.286.31.76.024 1.06l-2.024 2.12 2.024 2.119a.75.75 0 0 1-1.084 1.036l-2.52-2.638a.75.75 0 0 1 0-1.036l2.52-2.637a.75.75 0 0 1 1.06-.024'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
